import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const Training = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Training</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.requireAnnualFatigueTraining}
                  onChange={(e) => handleChange('requireAnnualFatigueTraining', e.target.checked)}
                />
              }
              label="Require Annual Fatigue Training (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Training Renewal Period (Months)"
              type="number"
              value={baseline.trainingRenewalPeriodMonths}
              onChange={(e) => handleChange('trainingRenewalPeriodMonths', parseInt(e.target.value))}
              inputProps={{ min: 6, max: 24 }}
              helperText="Annual renewal period"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default Training;
